import React from "react";
import "./Realestatebrokerage.css";
import centerimage from "../../assets/شهادة-فال-1.png"; 
import logoimage from "../../assets/akari-logo.png";
import Footer from "../Footer";

const Realestatebrokerage = () => {
  return (
    <>
    
    <div className="heading-h1">
    <h1 className="title">خدمة الوساطة العقارية</h1>
    </div>
    
      <div className="logo-container">
      <img src={logoimage} alt="Akari Logo" className="logo" />
      </div>
      <div className="content">
      <h3>رقم الرخصة-1200016943</h3>
      <h2 className="section-title">تعريف الخدمة</h2>
        <p className="text">خدمة الوساطة العقارية</p>
        <h2 className="section-title">مقدم الخدمة:</h2>
        <p className="text">مكتب عبدالله ناصر العتيق العقاري</p>
      <div className="image-container">
        <img src={centerimage} alt="Center" className="center-image" />
      </div>

      </div>

      
    
      <Footer/>
     
      
      </>
  );
};

export default Realestatebrokerage;
